import React from 'react';
export function DanderInfo() {
  return <section className="mb-16" data-id="element-21">
      <h2 className="text-2xl font-bold mb-6 text-blue-900" data-id="element-22">
        The Hidden Truth About Cat Dander
      </h2>
      <div className="text-lg mb-6" data-id="element-23">
        <p className="mb-4" data-id="element-24">
          It wasn't dust. It wasn't "just age." It was something far more stubborn.
        </p>
        <p className="mb-4" data-id="element-25">
          Every time a cat grooms, its saliva leaves behind a microscropic protein called
          <strong data-id="element-26"> Fel d1</strong>.[1] Think of it like glitter in the air - once it's loose, 
          it floats everywhere, clings to furniture, and lingers for months! <strong data-id="element-27">No amount</strong> of vacumming
          or spraying can fully catch it.
        </p>
        <p className="mb-4" data-id="element-28">
          That's why so many cat parents say things like: 
        </p>
        <ul className="list-disc pl-6 text-lg space-y-2" data-id="element-29">
          <li data-id="element-30"> <em data-id="element-31">"I'm constantly vacuuming but it feels like fur and dander are everywhere"</em></li>
          <li data-id="element-32"><em data-id="element-33">"Doctors just told me to get rid of my cat… that’s not happening."</em></li>
        </ul>
      </div>
      <div className="bg-red-50 p-6 rounded-lg mb-8" data-id="element-34">
        <h3 className="text-xl font-semibold mb-4 text-red-800" data-id="element-35">
          Doctors warn prolonged exposure can:
        </h3>
        <ul className="list-disc pl-6 text-lg space-y-2" data-id="element-36">
          <li data-id="element-37">Damage lung tissue over time [3]</li>
          <li data-id="element-38">Increase risk of respiratory infections</li>
          <li data-id="element-39">Turn mild sensitivities into severe reactions</li>
        </ul>
      </div>
      <p className="text-lg mb-8" data-id="element-40">
        The heartbreaking part? Most cat owners are told their <strong data-id="element-41">only</strong> option is to give up the pet they love. [5].
      </p>
      <div className="flex justify-center" data-id="element-42">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tCMUYYTYGaFKiyzqNXJHsY/ChatGPT_Image_Sep_2%2C_2025%2C_10_07_29_PM.png" alt="Woman holding a cat with Fel d1 allergen particles visualized in the air" className="w-3/4 rounded-lg shadow-md" data-id="element-43" />
      </div>
    </section>;
}